import React, { useState, useEffect, useMemo } from 'react';
import HistoryListItem from './../items/HistoryListItem';
import IntervalService from './../../services/intervals';
import AddPerformance from './../dialogs/AddPerformance';
import TR from './../../Trans';
import DeleteDialog from './../dialogs/DeleteDialog';
import { Views } from './../../enums/enums';
import { useMediaQuery } from 'react-responsive';
import { checkIfMobile } from '../../services/screen';
import MuvikaService from './../../services/muvika';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import singersStore from '../../stores/singers';
import playerStore from '../../stores/player';
import messageStore from './../../stores/message';
import favoritesStore from './../../stores/favorites';
import settingsStore from '../../stores/settings';
import navigationStore from '../../stores/navigation';

function HistoryListContainer(props) {

  const [isAddPerformanceOpen, setIsAddPerformanceOpen] = useState(false);
  const [chosenTrack, setChosenTrack] = useState({});
  const [chosenPerformance, setChosenPerformance] = useState({});
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const sessionToken = sessionStore((state) => state.sessionToken);
  const addPerformanceToPlayQueue = performanceStore((state) => state.addPerformanceToPlayQueue);
  const addPerformanceToPlayList = performanceStore((state) => state.addPerformanceToPlayList);
  const playLists = performanceStore((state) => state.playLists);
  const getPlayLists = performanceStore((state) => state.getPlayLists);
  const deletePerformanceFromHistory = performanceStore((state) => state.deletePerformanceFromHistory);
  const getSingers = singersStore((state) => state.getSingers);
  const singers = singersStore((state) => state.singers);
  const historyItems = performanceStore((state) => state.history?.items);
  const setError = messageStore((state) => state.setError);
  const isPlaying = playerStore((state) => state.isPlaying);
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const favorites = favoritesStore((state) => state.tracks);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const setIsSwitching = playerStore((state) => state.setIsSwitching);
  const playQueue = performanceStore((state) => state.playQueue);
  const setMobilePlayerVisible = navigationStore((state) => state.setMobilePlayerVisible);
  const goToView = navigationStore((state) => state.goToView);

  useEffect(() => {
    if (!singers) {
      getSingers(sessionToken);
    }
    if (!playLists) {
      getPlayLists(sessionToken);
    }
  }, []);

  const handleOpenAddPerformance = (track) => {
    if (track) {
      MuvikaService.getLastPerformance(sessionToken, track.track_id)
        .then(function (res) {
          if (res.data.error) {
            setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            if (res.data.data.profile_id) {
              track.last_pitch = res.data.data.pitch;
              track.last_singer_id = res.data.data.profile_id;
            }
            setChosenTrack(track);
            setIsAddPerformanceOpen(true);
          }
        })
        .catch(function () { });
    }
  };

  const handleCloseAddPerformance = () => {
    setIsAddPerformanceOpen(false);
  };

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleAddPerformance = (singerProfile, pitch, playList, toPos, isManual, playNow = false, isSongbookQueue = false) => {
    if (singerProfile && (pitch >= -3 && pitch <= 3)) {
      if (playList) {
        addPerformanceToPlayList(sessionToken, chosenTrack, singerProfile, pitch, playList.id, toPos);
        setIsAddPerformanceOpen(false);
      } else {
        if (isSongbookQueue) {
          MuvikaService.createSongRequest(sessionToken, "add", chosenTrack.track_id, singerProfile.id, pitch, [])
            .then(function (res) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              }
            })
            .catch(function () { });
          setIsAddPerformanceOpen(false);
        } else {
          setIsAutoPlayOn(settingsStore.getState().settings?.autoplay_enabled);
          addPerformanceToPlayQueue(sessionToken, chosenTrack, singerProfile, pitch, toPos, isManual, playNow);
          setIsAddPerformanceOpen(false);
        }
      }
      if (toPos == 0 && playNow) {
        IntervalService.clearAllIntervals();
        setIsAutoPlayOn(false);
        setIsSwitching(true);
        let isMobile = checkIfMobile();
        if (isMobile) {
          goToView(Views.Blank);
          setMobilePlayerVisible(true);
        }
      }
    } else {
      setError(sessionToken, 0, TR.cm_select_singer);
    }
  };

  const handleDeletion = () => {
    console.log("render again", chosenPerformance);
    deletePerformanceFromHistory(sessionToken, chosenPerformance?.unique_id);
    setIsDeleteDialogOpen(false);
  };

  const historyItemIds = useMemo(() => {
    return historyItems?.map((p) => p.unique_id);
  }, [historyItems]);

  const trackList = useMemo(() => {
    if (historyItemIds) {
      console.log("itemshist", historyItemIds);
      return historyItemIds.map((performanceId, index) =>
        <HistoryListItem
          index={index}
          key={performanceId}
          performanceId={performanceId}
          openDeleteDialog={(performance) => {
            console.log("render again", chosenPerformance);
            setChosenPerformance(performance);
            handleOpenDeleteDialog();
          }}
          onAddPerformance={(performance) => {
            setChosenPerformance(performance);
            handleOpenAddPerformance(performance.track);
          }}
        />
      );
    }
    return null;
  }, [historyItemIds]);

  return (
    <div>
      <DeleteDialog
        open={isDeleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        onDeletion={handleDeletion}
        title={TR.cm_are_you_sure}
        cancel={TR.cm_cancel}
        delete={TR.cm_delete}
      />
      <AddPerformance
        open={isAddPerformanceOpen}
        isPlaying={isPlaying.isPlaying}
        onClose={handleCloseAddPerformance}
        onAddPerformance={handleAddPerformance}
        track={chosenTrack}
        singers={singers}
        playLists={playLists}
        defaultPitch={chosenPerformance?.pitch}
        playQueue={playQueue}
      />
      {trackList}
    </div>
  );
}

export default HistoryListContainer;